import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class GeoService {
  constructor(private http: HttpClient) {}

  getLocation(): Observable<any> {
    // API pública de geolocalización
    return this.http.get('https://ipapi.co/json/');
  }
}
